// Runtime Configuration Manager
// This allows dynamic configuration changes without rebuilding

// websiteConfig/appConfigData datang dari app.config.js->getClientConfig(),
// yang baca langsung dari import.meta.env di browser - itu jalan di dev
// MAUPUN build. (Sempat dicoba pakai Vite `define` constant __APP_CONFIG__,
// tapi Vite CUMA static-replace define di sisi client pas build; pas
// `vite dev` itu selalu no-op sehingga __APP_CONFIG__ selalu 'undefined' di
// dev - itu sebabnya document.title/favicon kelihatan "tidak berubah" walau
// .env sudah diisi & dev server sudah di-restart.)
import { websiteConfig, appConfigData } from '../../app.config.js'

const buildDefaultConfig = () => ({
  website: { ...websiteConfig, colors: { ...websiteConfig.colors } },
  app: { ...appConfigData },
})

class RuntimeConfig {
  constructor() {
    this.config = buildDefaultConfig()

    this.listeners = []
    this.loadFromStorage()
  }

  // Load configuration from localStorage
  loadFromStorage() {
    try {
      const stored = localStorage.getItem('tms-config')
      if (stored) {
        const parsed = JSON.parse(stored)
        this.config = { ...this.config, ...parsed }
      }
    } catch (error) {
      console.warn('Failed to load config from storage:', error)
    }
  }

  // Save configuration to localStorage
  saveToStorage() {
    try {
      localStorage.setItem('tms-config', JSON.stringify(this.config))
    } catch (error) {
      console.warn('Failed to save config to storage:', error)
    }
  }

  // Get configuration value
  get(path) {
    return path.split('.').reduce((obj, key) => obj?.[key], this.config)
  }

  // Set configuration value
  set(path, value) {
    const keys = path.split('.')
    const lastKey = keys.pop()
    const target = keys.reduce((obj, key) => obj[key] = obj[key] || {}, this.config)
    target[lastKey] = value
    
    this.saveToStorage()
    this.notifyListeners()
  }

  // Update multiple configuration values
  update(updates) {
    Object.assign(this.config, updates)
    this.saveToStorage()
    this.notifyListeners()
  }

  // Reset to default configuration (default = build-time config from env, not always 'BTMS')
  reset() {
    this.config = buildDefaultConfig()

    localStorage.removeItem('tms-config')
    this.notifyListeners()
  }

  // Get all configuration
  getAll() {
    return { ...this.config }
  }

  // Subscribe to configuration changes
  subscribe(callback) {
    this.listeners.push(callback)
    return () => {
      const index = this.listeners.indexOf(callback)
      if (index > -1) {
        this.listeners.splice(index, 1)
      }
    }
  }

  // Notify all listeners of configuration changes
  notifyListeners() {
    this.listeners.forEach(callback => callback(this.config))
  }

  // Apply colors to CSS custom properties
  applyColors() {
    const root = document.documentElement
    root.style.setProperty('--primary-color', this.config.website.colors.primary)
    root.style.setProperty('--secondary-color', this.config.website.colors.secondary)
    root.style.setProperty('--accent-color', this.config.website.colors.accent)
    root.style.setProperty('--active-color', this.config.website.colors.accent)
  }

  // Update page title and favicon
  updatePageMeta() {
    const titleElement = document.getElementById('page-title')
    const faviconElement = document.getElementById('favicon')
    
    if (titleElement) {
      titleElement.textContent = this.config.website.title
    }
    
    if (faviconElement) {
      faviconElement.href = this.config.website.icon
    }
  }
}

// Create singleton instance
const runtimeConfig = new RuntimeConfig()

// Apply initial configuration
runtimeConfig.applyColors()
runtimeConfig.updatePageMeta()

export default runtimeConfig
